import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=05bea08f&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=js"
export * from "./MainDashboard.vue?vue&type=script&lang=js"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=05bea08f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bea08f",
  null
  
)

export default component.exports